'use client'

import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import { mtc } from '../../../utils/style-helpers'
import { tabsListStyles, tabsTriggerStyles, tabsContentStyles } from './styles'

const TabsRoot = ({
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root>) => (
  <TabsPrimitive.Root {...props} />
)

type TabsListProps = React.ComponentPropsWithoutRef<
  typeof TabsPrimitive.List
> & {
  variant?: 'default' | 'outline'
  fullWidth?: boolean
  scrollable?: boolean
}

const TabsList = ({
  className,
  variant = 'default',
  fullWidth,
  ...props
}: TabsListProps) => (
  <TabsPrimitive.List
    className={mtc(tabsListStyles({ variant, fullWidth }), className)}
    {...props}
  />
)
TabsList.displayName = TabsPrimitive.List.displayName

type TabsTriggerProps = React.ComponentPropsWithoutRef<
  typeof TabsPrimitive.Trigger
> & {
  variant?: 'default' | 'outline'
  fullWidth?: boolean
}

const TabsTrigger = ({
  className,
  variant = 'default',
  fullWidth,
  ...props
}: TabsTriggerProps) => (
  <TabsPrimitive.Trigger
    className={mtc(tabsTriggerStyles({ variant, fullWidth }), className)}
    {...props}
  />
)
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

type TabsContentProps = React.ComponentPropsWithoutRef<
  typeof TabsPrimitive.Content
> & {
  variant?: 'default' | 'outline'
}

const TabsContent = ({
  className,
  variant = 'default',
  ...props
}: TabsContentProps) => (
  <TabsPrimitive.Content
    className={mtc(tabsContentStyles({ variant }), className)}
    {...props}
  />
)
TabsContent.displayName = TabsPrimitive.Content.displayName

export const Tabs = Object.assign(TabsRoot, {
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent,
})
